import { Link } from 'react-router-dom';
import ComicCard from '@/components/base/ComicCard';
import { getRecommendedComics } from '@/mocks/comics';

export default function FeaturedComics() {
  const featured = getRecommendedComics();

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900"
              style={{ fontFamily: 'var(--font-heading)' }}>
              精选推荐
            </h2>
            <p className="text-sm text-foreground-400 mt-2">编辑精心挑选的高品质韩漫佳作</p>
          </div>
          <Link
            to="/category/love"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
          {featured.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}